/* @flow */

import React from "react";
import cn from "classnames";
import { useTranslate } from "@awardit/react-use-translate";
import MainLogo from "icons/refunder-logo.svg";
import useDevice from "helpers/hooks/use-device";

import styles from "./styles.scss";

type Props = {
  className?: string,
  useMobile?: boolean,
};

const Logo = ({ className, ...props }: Props): React$Node => {
  const t = useTranslate();
  const tiny = Number.parseInt(styles.bpTiny, 10);
  const medium = Number.parseInt(styles.bpMedium, 10);
  const isMobile = useDevice("lt", tiny);
  const isDesktop = useDevice("gt", medium);

  return (
    <div {...props} className={cn(styles.container, className)}>
      <div className={cn(
        styles.logo,
        { [styles.mobile]: isMobile },
        { [styles.desktop]: isDesktop }
      )}
      >
        <MainLogo
          aria-label={t("LOGO.TITLE")}
          className={styles.logoSvg}
        />
        <div className={styles.logoText}>
          <span className={styles.title}>{t("APP.NAME")}</span>
          <span className={styles.subtitle}>{t("LOGO.SUBTITLE")}</span>
        </div>
      </div>
    </div>
  );
};

export default Logo;
